import { EnumStorageTransactionType } from './Generated';
import { SelectOption } from '@synqo/frontend-component-library';

// @ai-generated 2026-10-21T16:00:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export const getEnumStorageTransactionTypeLabel = (value: EnumStorageTransactionType) => {
    switch (value) {
        case EnumStorageTransactionType.Incoming:
            return 'Zugang';
        case EnumStorageTransactionType.Outgoing:
            return 'Abgang';
        case EnumStorageTransactionType.Stocktaking:
            return 'Inventur';
        default:
            return 'Nicht definiert';
    }
};

export const enumStorageTransactionTypeOptions: SelectOption<EnumStorageTransactionType>[] = [
    {
        name: 'incoming',
        label: getEnumStorageTransactionTypeLabel(EnumStorageTransactionType.Incoming),
        value: EnumStorageTransactionType.Incoming,
    },
    {
        name: 'outgoing',
        label: getEnumStorageTransactionTypeLabel(EnumStorageTransactionType.Outgoing),
        value: EnumStorageTransactionType.Outgoing,
    },
    {
        name: 'stocktaking',
        label: getEnumStorageTransactionTypeLabel(EnumStorageTransactionType.Stocktaking),
        value: EnumStorageTransactionType.Stocktaking,
    },
];
